import React, { ReactNode } from 'react';
import { Provider } from 'react-redux';
import { Modal } from 'antd';
import { store } from '../../store';

import { GlobalModalProps } from '../orders/PlaceOrder';

interface GlobalModalProps {
  content: ReactNode;
}

export const GlobalModalHandler = ({ content }: GlobalModalProps) => {
  Modal.info({
    ...GlobalModalProps,
    content: <Provider store={store}>{content}</Provider>,
  });
};

export const GlobalModalClose = () => {
  Modal.destroyAll();
};
